import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@carnica/ui-kit';
import { Link } from '@beef/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { IconRefresh } from '@carnica/graphics';
import { selectIsClickableTariff, selectIsMobileUser, selectMobileConnectionBlockError, selectMobileConnectionTariff, selectMobileTariffPowerPending, selectTariffBlock } from "../../store/selectors";
import { ConnectionBlockActionCreator } from "../../store/actions";
import { Card } from "../../Card";
import { tariff } from "../../constants/tariff";
import { getNextBillingDate, getTariffPrice } from "../../utils";
import { selectMobileConnectionBlockPending, selectMobileConnectionBlockPricePending, selectRedesignMobileConnectionPrice, selectTariffPeriodDays, selectTariffPrice, selectTariffUrl } from "./store";
import { Accumulators } from "./Accumulators";
import styles from "./styles.pcss";
import { InfoTag } from "./InfoTag";
import { selectUserType } from "../../../../../store/selectors";
import { pushFubAnalytics } from "../../utils/analytics";
import { ANALYTICS_ACTION, ANALYTICS_OBJECT_TYPE } from "../../constants/analytics";
import { Skeleton } from "../../../common/Skeleton";
var cn = classNames.bind(styles);
var _MobileTariff = function _MobileTariff(_ref) {
  var name = _ref.name,
    price = _ref.price,
    periodDays = _ref.periodDays,
    billingDate = _ref.billingDate,
    pending = _ref.pending,
    tariffUrl = _ref.tariffUrl,
    target = _ref.target,
    userType = _ref.userType,
    hasError = _ref.hasError,
    fetchMobileConnection = _ref.fetchMobileConnection,
    fetchConnectionPrice = _ref.fetchConnectionPrice,
    isClickable = _ref.isClickable;
  var isMobile = useIsMobileDimension();
  var nextBillingDate = getNextBillingDate(billingDate);
  var handleRefreshIconClick = function handleRefreshIconClick() {
    fetchMobileConnection();
    fetchConnectionPrice();
  };
  var handleTariffClick = function handleTariffClick(e) {
    if (!isClickable) {
      e.preventDefault();
    }
    pushFubAnalytics(target, {
      account_type: userType,
      action: ANALYTICS_ACTION.CLICK,
      item_type: ANALYTICS_OBJECT_TYPE.WIDGET,
      widget_name: 'tariff'
    });
  };
  if (pending) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrapper'),
      "data-t-id": "components-MobileTariff"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cn('short')
    }));
  }
  if (hasError) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrapper')
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('error')
    }, /*#__PURE__*/React.createElement(Text, {
      className: cn('name'),
      color: "secondary",
      size: isMobile ? 'xs' : 'm'
    }, tariff.error), /*#__PURE__*/React.createElement(IconRefresh, {
      className: cn('refresh'),
      color: "secondary",
      onClick: handleRefreshIconClick
    })));
  }
  return /*#__PURE__*/React.createElement(Link, {
    className: cn('link'),
    href: tariffUrl,
    isNoUnderline: true,
    onClick: function onClick(e) {
      return handleTariffClick(e);
    }
  }, /*#__PURE__*/React.createElement(Card, {
    color: "secondary",
    size: "m",
    "data-t-id": "components-MobileTariff"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title'),
    "data-t-id": "components-MobileTariff"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('name'),
    size: isMobile ? 'xs' : 'm'
  }, name), /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: isMobile ? 'xs' : 's'
  }, getTariffPrice(price, periodDays))), /*#__PURE__*/React.createElement(InfoTag, null), /*#__PURE__*/React.createElement(Accumulators, {
    target: target
  }), !!nextBillingDate && /*#__PURE__*/React.createElement(Text, {
    className: cn('description'),
    color: "secondary",
    size: isMobile ? '2xs' : 'xs'
  }, "".concat(tariff.defaultNextBillingDateText, " ").concat(nextBillingDate))));
};
var mapStateToProps = function mapStateToProps(state) {
  var _selectMobileConnecti, _selectRedesignMobile, _selectRedesignMobile2;
  var pending = selectMobileConnectionBlockPricePending(state) || selectMobileConnectionBlockPending(state) || selectMobileTariffPowerPending(state);
  var hasError = selectMobileConnectionBlockError(state);
  return {
    name: (_selectMobileConnecti = selectMobileConnectionTariff(state)) === null || _selectMobileConnecti === void 0 ? void 0 : _selectMobileConnecti.title,
    price: selectTariffPrice(state),
    periodDays: selectTariffPeriodDays(state),
    shouldRender: selectIsMobileUser(state) && (!!selectTariffBlock(state) || pending || hasError),
    billingDate: (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 ? void 0 : (_selectRedesignMobile2 = _selectRedesignMobile.data) === null || _selectRedesignMobile2 === void 0 ? void 0 : _selectRedesignMobile2.billingDate,
    pending: pending,
    tariffUrl: selectTariffUrl(state) || '',
    userType: selectUserType(state),
    hasError: hasError,
    isClickable: selectIsClickableTariff(state)
  };
};
var mapDispatchToProps = {
  fetchMobileConnection: ConnectionBlockActionCreator.fetchMobileConnection,
  fetchConnectionPrice: ConnectionBlockActionCreator.fetchConnectionPrice
};
export var MobileTariff = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_MobileTariff);